import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { useTenantUserRemoveMutation } from "@/v2-backoffice-client/tenant/user/remove/tenant.user.remove.mutation"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"

export type UserTenantManageAddedItemProps = {
  tenant: TenantFragment
  userId: number
  roleName?: string
  onRemoved(): void
}

function UserTenantManageAddedItem(props: UserTenantManageAddedItemProps) {
  const { tenant, userId, roleName, onRemoved } = props

  const [remove, { error, loading }] = useTenantUserRemoveMutation()
  errorToast(error, { title: "Failed to remove from team" })

  function handleRemove() {
    remove({ variables: { tenantId: tenant.Id, userId } })
    onRemoved()
  }

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={tenant.Name}
        secondary={tenant.CustomerName ?? undefined}
      />
      {roleName && <Manage.Item.Badge>{roleName}</Manage.Item.Badge>}
      <ConfirmButton
        size="xs"
        variant="destructive"
        isSquare
        iconSrc="trash"
        content="Remove user from team"
        confirmContent="Remove?"
        confirmVariant="destructive"
        isLoading={loading}
        onConfirm={handleRemove}
      />
    </Manage.Item>
  )
}

export default UserTenantManageAddedItem
